import { insertHtmlBlock } from './operations';

export const slashMenu = {
  'Custom HTML': { icon: 'code', transform: insertHtmlBlock },
};

export default slashMenu;
